import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { BooleanToSubscribedDirective } from './directives/boolean-to-subscribed.directive';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';

@NgModule({
  declarations: [HomePageComponent, BooleanToSubscribedDirective],
  imports: [CommonModule, FormsModule, IonicModule, HomePageRoutingModule, MiscModule]
})
export class HomePageModule {}
